import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export const useRouterTools = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParam = useCallback(
    (key: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());

      params.set(key, value);
      setSearchParams(params);
    },
    [searchParams, setSearchParams]
  );

  const deleteSearchParam = useCallback(
    (key: string) => {
      const params = new URLSearchParams(searchParams.toString());

      params.delete(key);
      setSearchParams(params);
    },
    [searchParams, setSearchParams]
  );

  const getSearchParam = useCallback(
    (key: string) => searchParams.get(key),
    [searchParams]
  );

  return {
    updateSearchParam,
    getSearchParam,
    deleteSearchParam,
    location,
    navigate,
    searchParams,
    setSearchParams,
  };
};
